"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var defaultSizes = _a.theme.sizes.default, gap = _a.gap, column = _a.column, columnReverse = _a.columnReverse;
    if (gap === undefined || !(gap in defaultSizes)) {
        return '';
    }
    if (column || columnReverse) {
        return "\n      &> *:not(:last-child) {\n        margin-bottom: " + defaultSizes[gap] + ";\n      }\n    ";
    }
    return "\n    &> *:not(:last-child) {\n      margin-right: " + defaultSizes[gap] + ";\n    }\n  ";
});
